module.exports = __webpack_public_path__ + "img/logo-loto-plus-hotpicks-2x.3f0a0adb.jpg";